module.exports = __webpack_public_path__ + "static/Mont_Blanc-c990d49878e1adf5a92aacc1d541e370.jpg";